var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClipboard = function SvgClipboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.695,16.262c0-1.863,1.197-3.036,3.099-3.036s3.099,1.173,3.099,3.036H8.695L8.695,16.262z M11.793,12.214 c-1.141,0-2.066-0.906-2.066-2.024s0.925-2.024,2.066-2.024s2.066,0.906,2.066,2.024S12.934,12.214,11.793,12.214z M13.653,4.119 h1.653v2.428H8.695V4.119h1.653C10.347,3.226,11.088,2.5,12,2.5S13.653,3.225,13.653,4.119z M17.785,4.928 c0.912,0,1.653,0.725,1.653,1.619v11.333c0,0.893-0.741,1.619-1.653,1.619H6.215c-0.912,0-1.653-0.726-1.653-1.619V6.548 c0-0.894,0.741-1.619,1.653-1.619h0.827v1.619H6.215v11.333h11.57L17.784,6.548h-0.827V4.928L17.785,4.928L17.785,4.928z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClipboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clipboard.9c0ac4f1.svg";
export { ForwardRef as ReactComponent };